export const styles = {
  container: {
    position: { xs: 'static', sm: 'relative' },
    flex: 1,
    maxWidth: { xs: 160, sm: 280, md: 350 },
    mx: { xs: 0.5, sm: 1 },
  },
  inputBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'action.hover',
    borderRadius: 1,
    px: 1,
    height: 32,
  },
  searchIcon: {
    color: 'text.secondary',
    fontSize: '1.1rem',
    mr: 0.5,
  },
  textField: {
    '& .MuiInput-root': {
      padding: 0,
      fontSize: '0.8rem',
    },
    '& .MuiInput-root:before, & .MuiInput-root:after': {
      display: 'none',
    },
  },
  spinner: {
    ml: 0.5,
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    maxHeight: 300,
    overflow: 'auto',
    zIndex: 1300,
    backgroundColor: 'background.paper',
    mt: { xs: 0, sm: 0.5 },
    boxShadow: 3,
    borderRadius: 1,
  },
  resultRow: {
    p: 1,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
    borderBottom: '1px solid',
    borderColor: 'divider',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 44,
  },
  resultName: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontWeight: 'medium',
    fontSize: '0.825rem',
    lineHeight: 1.2,
  },
  resultSymbol: {
    display: 'block',
    color: 'text.secondary',
    fontSize: '0.7rem',
    lineHeight: 1.2,
  },
  resultExpiry: {
    color: 'text.secondary',
    fontSize: '0.7rem',
    lineHeight: 1.2,
  },
  noResults: {
    p: 2,
    textAlign: 'center',
    color: 'text.secondary',
    fontSize: '0.8rem',
  },
};
